import type { ReactNode } from 'react';

export interface TextLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  /** `muted` for footer/legal rows; `default` for inline accent links. */
  variant?: 'default' | 'muted';
  'data-testid'?: string;
}

/**
 * External text link for marketing/legal footer rows.
 */
export function TextLink({
  href,
  children,
  className = '',
  variant = 'default',
  'data-testid': dataTestId,
}: TextLinkProps) {
  const variantClass = variant === 'muted' ? 'ds-footer-link' : 'ds-link';

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={dataTestId}
      className={`${variantClass} ${className}`.trim()}
    >
      {children}
    </a>
  );
}
